import type { Provider } from '../../holistic/types/HolisticSummary';
import { requestBuilder } from '../../http/RequestBuilder';
import type { IGoalAccountLink } from '../types/Goal';

interface UpdateGoalAccountLinkBody {
    accountId: string;
    provider: Provider;
}

interface UpdateGoalAccountLinkURLParams {
    goalAccountLinkId: string;
}

const useUpdateGoalAccountLink = requestBuilder.mutation<
    IGoalAccountLink,
    UpdateGoalAccountLinkBody,
    UpdateGoalAccountLinkURLParams
>({
    endpoint: ({ goalAccountLinkId }) =>
        `/api/guidance/goals/account-link/${goalAccountLinkId}`,
    method: 'PATCH',
});

export default useUpdateGoalAccountLink;
